// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import AppleLogoSvg from "./brand/apple-logo.svg";
import KakaoLogoSvg from "./brand/kakao-logo.svg";
import NaverLogoSvg from "./brand/naver-logo.svg";
import TeslaLogoSvg from "./brand/tesla-logo.svg";
import CardocLogoSvg from "./brand/cardoc-logo.svg";
import CardocMarkSvg from "./brand/cardoc-mark.svg";
import CardocAppIconSvg from "./brand/cardoc-app-icon.svg";
import GooglePlaystoreLogoSvg from "./brand/google-playstore-logo.svg";

var cardocAppIcon = CardocAppIconSvg;

var appleLogo = AppleLogoSvg;

var kakaoLogo = KakaoLogoSvg;

var naverLogo = NaverLogoSvg;

var teslaLogo = TeslaLogoSvg;

var googlePlayStoreLogo = GooglePlaystoreLogoSvg;

var cardocMark = CardocMarkSvg;

var cardocLogo = CardocLogoSvg;

function convert(t) {
  if (t === "cardoc-app-icon") {
    return cardocAppIcon;
  } else if (t === "cardoc-logo") {
    return cardocLogo;
  } else if (t === "cardoc-mark") {
    return cardocMark;
  } else if (t === "apple-logo") {
    return appleLogo;
  } else if (t === "kakao-logo") {
    return kakaoLogo;
  } else if (t === "tesla-logo") {
    return teslaLogo;
  } else if (t === "naver-logo") {
    return naverLogo;
  } else {
    return googlePlayStoreLogo;
  }
}

function CDS_Icon_Brand(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return React.createElement(convert(props.name), {
              className: TailwindMerge.twMerge("w-6 h-6", className),
              style: props.style,
              height: "24",
              width: "24"
            });
}

var make = CDS_Icon_Brand;

export {
  cardocAppIcon ,
  appleLogo ,
  kakaoLogo ,
  naverLogo ,
  teslaLogo ,
  googlePlayStoreLogo ,
  cardocMark ,
  cardocLogo ,
  convert ,
  make ,
}
/* cardocAppIcon Not a pure module */
